module.exports = __webpack_public_path__ + "img/electronic_no_zone_selected.c537f5a6.svg";